/**
 * Worldview zoom bounds + per-notch factor (HEX-74; out-cap widened HEX-144).
 *
 * Zoom multiplies the base `HEX_SIZE`; `1` is the shipped slice-1 framing. Each
 * wheel notch / `+`/`-` press multiplies by `ZOOM_STEP`.
 *
 * `ZOOM_MIN` is the zoom-*out* cap. HEX-144 lowers it from 0.45 to 0.18 so the
 * survey view reads several town-spacings (`SETTLEMENT_MIN_SPACING` ≈ 24 hexes)
 * of the explored/memory map at once — the playtest miss was a follow-the-
 * compass loop where the winding corridor to the next town never fit on screen.
 * `ZOOM_MAX` (zoom-in cap) is unchanged: the disk mustn't balloon past a couple
 * of rings.
 */
export const ZOOM_MIN = 0.18;
export const ZOOM_MAX = 2.2;
export const ZOOM_STEP = 1.12;

/** Clamp a desired zoom factor into the worldview bounds. Pure (HEX-144). */
export function clampZoom(zoom: number): number {
  return Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, zoom));
}
